<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <DirPath :path="['Reportes', 'Evolución']" />
        <HeaderView v-bind="headerData" />

        <ReportsConfig v-if="!reports || !reports.school || !reports.course" />
        <template v-if="reports && reports.school && reports.course">
          <HeaderReport title="Porcentaje de logro" />

          <template v-if="showData">
            <transition name="slide-fade">
              <div v-if="showDetails">
                <div class="row mb-5 mt-3">
                  <div class="col-md-6 ">
                    <DropSelect
                      v-bind="selectEvolution"
                      :icon="'analysis'"
                      v-model="selectEvolution.selected"
                      :zIndex="2"
                    />
                  </div>
                  <div class="col-md-6">
                    <DropSelect
                      v-bind="selectInterval"
                      :icon="'schedule'"
                      v-model="selectInterval.selected"
                      :zIndex="2"
                    />
                  </div>
                </div>

                <template v-if="statusEvolution.showData">
                  <div class="row">
                    <button
                      class="button col-md-2"
                      :class="{
                        secondary: !general,
                        primary: general,
                      }"
                      @click="general = true"
                    >
                      General
                    </button>
                    <button
                      class="button col-md-2 ml-3"
                      :class="{
                        secondary: general,
                        primary: !general,
                      }"
                      @click="general = false"
                    >
                      Por habilidades
                    </button>
                    <div v-show="!general" class="col-md-5">
                      <DropSelect
                        v-bind="selectHability"
                        :icon="'star'"
                        v-model="selectHability.selected"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4" v-if="studentsDetail">
                      <div class="row">
                        <div class="col">
                          <table class="table elevation-1">
                            <thead class="text-logo">
                              <tr>
                                <th class="text-center px-0">Nombre</th>
                              </tr>
                            </thead>
                            <tbody class="text-gray pointer custom-scroll">
                              <tr
                                v-for="(student, i) in data.readers"
                                :key="i"
                                @click="selectedStudent = i"
                              >
                                <td
                                  class="text-center px-0"
                                  :class="{ 'text-logo': i == selectedStudent }"
                                >
                                  {{ student.reader.firstname }}
                                  {{ student.reader.lastname }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-center"
                      :class="{
                        'col-md-12': !studentsDetail,
                        'col-md-8': studentsDetail,
                      }"
                    >
                      <BarLineChartContainer
                        :data="chartData.evolution"
                        :key="studentsDetail && selectedStudent"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <button
                      class="button mx-auto"
                      :class="{
                        secondary: !studentsDetail,
                        primary: studentsDetail,
                      }"
                      @click="studentsDetail = !studentsDetail"
                    >
                      {{ studentButtonText }}
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div class="row">
                    <div class="col text-center">
                      <Spinner v-if="statusEvolution.showSpinner" />
                    </div>
                  </div>
                </template>
              </div>
            </transition>
          </template>
          <template v-else>
            <div class="row">
              <div class="col text-center">
                <Spinner v-if="showSpinner" />
              </div>
            </div>
          </template>

          <div class="row" v-if="showData && error">
            <div class="col text-center">
              {{ error }}
            </div>
          </div>
        </template>

        <div class="row">
          <FooterComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import DropSelect from "@/components/DropSelect";
import FooterComponent from "@/components/Footer";
import BarLineChartContainer from "@/components/BarContainer/BarLineChartContainer";
import HeaderReport from "@/components/HeaderReport";
import HeaderView from "@/components/HeaderView";
import ReportsConfig from "@/components/ReportsConfig";
import Spinner from "@/components/Spinner";

export default {
  name: "evolution",
  components: {
    DirPath,
    FooterComponent,
    DropSelect,
    BarLineChartContainer,
    HeaderReport,
    HeaderView,
    ReportsConfig,
    Spinner,
  },
  data() {
    let { primCol, secCol } = this.$store.getters;

    return {
      general: true,
      showData: false,
      showSpinner: false,
      data: null,
      error: "",
      firstDay: "",
      lastDay: "",
      headerData: {
        title: "Evolución",
        subTitle: "",
        body:
          "Compara cómo estaban tus estudiantes al comienzo con su estado actual",
        img: require("@/assets/images/Componente 33 – 1.svg"),
      },
      secCol,
      initialDate: null,
      endDate: null,
      showDetails: false,
      individualResults: false,
      selectedStudent: 0,
      studentsDetail: false,
      selectEvolution: {
        options: [
          {
            text: "General",
            value: 1,
          },
          {
            text: "Desafíos",
            value: 2,
          },
          {
            text: "Evaluaciones de libros",
            value: 3,
          },
        ],
        placeholder: "Seleccione tipo de evaluación",
        supTitle: "Evaluación",
        id: "type",
        selected: null,
      },
      selectHability: {
        options: [
          {
            text: this.$t("habilities.LOC"),
            value: "porcentajeCorrectasLocalizar",
          },
          {
            text: this.$t("habilities.RV"),
            value: "porcentajeCorrectasReflexionar",
          },
          {
            text: this.$t("habilities.IN"),
            value: "porcentajeCorrectasIntegrar",
          },
        ],
        placeholder: "Seleccione habilidad",
        supTitle: "Habilidad",
        id: "hability",
        selected: "porcentajeCorrectasLocalizar",
      },
      selectInterval: {
        options: [
          {
            text: "Mensual",
            value: "true",
          },
          {
            text: "Semanal",
            value: "false",
          },
        ],
        placeholder: "Seleccione intervalo",
        supTitle: "Intervalo",
        id: "interval",
        selected: null,
      },
      chartData: {
        total: {
          label: "Porcentaje de logro",
          barColor: primCol,
          data: {},
        },
        evolution: {
          label: "",
          barColor: primCol,
          data: {},
        },
      },
      statusEvolution: {
        showData: false,
        showSpinner: false,
        data: null,
        error: "",
      },
    };
  },
  watch: {
    "reports.dateFilterVal"() {
      if (this.reports.dateFilterVal) this.storeDates();
    },
    "reports.initialDate"() {
      if (this.reports.dateFilterVal == 3) this.storeDates();
    },
    "reports.endDate"() {
      if (this.reports.dateFilterVal == 3) this.storeDates();
    },
    "selectInterval.selected"() {
      if (this.selectInterval.selected && this.selectEvolution.selected)
        this.getEvolutionData();
    },
    "selectEvolution.selected"() {
      if (this.selectInterval.selected && this.selectEvolution.selected)
        this.getEvolutionData();
    },
    selectedStudent() {
      let showDetails = false;
      if (this.studentsDetail) showDetails = true;
      this.setChartData(showDetails);
    },
    studentsDetail() {
      let showDetails = false;
      if (this.studentsDetail) showDetails = true;
      this.setChartData(showDetails);
    },
    propertyToShowInGraph() {
      let showDetails = false;
      if (this.studentsDetail) showDetails = true;
      this.setChartData(showDetails);
    },
  },
  methods: {
    setChartData(showDetails) {
      this.chartData.evolution.data = {};
      this.chartData.evolution.label = "";

      let evolution = this.data.report;

      if (showDetails)
        evolution = this.data.readers[this.selectedStudent].evolution;

      for (let item of evolution) {
        let label = item.index
          ? item.dateTo.split(" ")[0]
          : "Diagnóstico inicial";

        this.chartData.evolution.data[label] = item[this.propertyToShowInGraph];
      }
    },
    formatDates(firstDay, lastDay) {
      let date1 = `${firstDay.getFullYear()}-${(
        "0" +
        (firstDay.getMonth() + 1)
      ).slice(-2)}-${("0" + firstDay.getDate()).slice(-2)}`;

      let date2 = `${lastDay.getFullYear()}-${(
        "0" +
        (lastDay.getMonth() + 1)
      ).slice(-2)}-${("0" + lastDay.getDate()).slice(-2)}`;

      return [date1, date2];
    },
    storeDates() {
      if (!this.reports.dateFilterVal) return;

      this.showData = false;
      this.showSpinner = true;
      this.data = null;
      this.error = "";

      let date, firstDay, lastDay, date1, date2;

      switch (this.reports.dateFilterVal) {
        case "1":
          date = new Date();
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

          [date1, date2] = this.formatDates(firstDay, lastDay);
          break;
        case "2":
          firstDay = new Date();
          firstDay.setDate(firstDay.getDate() - 30);
          lastDay = new Date();

          [date1, date2] = this.formatDates(firstDay, lastDay);

          break;
        case "3":
          if (this.reports.initialDate && this.reports.endDate) {
            date1 = this.reports.initialDate;
            date2 = this.reports.endDate;
          } else {
            this.showSpinner = false;
            return;
          }
          break;
      }

      this.firstDay = date1;
      this.lastDay = date2;
      this.showSpinner = false;
      this.showData = true;
      this.showDetails = true;
    },
    async getEvolutionData() {
      this.statusEvolution.showData = false;
      this.statusEvolution.showSpinner = true;
      this.statusEvolution.data = null;
      this.statusEvolution.error = "";
      this.chartData.evolution.data = {};
      this.chartData.evolution.label = "";
      this.error = "";

      let endpoint;
      let evolutionParams;
      let interval = this.selectInterval.selected;
      let evolution = this.selectEvolution.selected;

      switch (this.reports.dateFilterVal) {
        case "1":
          endpoint = `/evaluacionDiagnostico/getEvolutionReportByParams?currentMonth=true`;
          break;
        case "2":
          endpoint = `/evaluacionDiagnostico/getEvolutionReportByParams?currentMonth=false`;
          break;
        case "3":
          if (this.reports.initialDate && this.reports.endDate) {
            endpoint = `/evaluacionDiagnostico/getEvolutionReportByParamsBetweenDates?date1=${this.firstDay}&date2=${this.lastDay}`;
          } else {
            this.statusEvolution.showSpinner = false;
            return;
          }
          break;
      }

      switch (evolution) {
        case 1:
          evolutionParams = "&general=true&inTest=true";
          break;
        case 2:
          evolutionParams = "&general=false&inTest=true";
          break;
        case 3:
          evolutionParams = "&general=false&inTest=false";
          break;
      }

      let apiUrl = `${this.dataUrl}${endpoint}&courseId=${this.reports.course}&byMonth=${interval}${evolutionParams}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.data = data.content;

          for (let item of data.content.report) {
            let label = item.index
              ? item.dateTo.split(" ")[0]
              : "Diagnóstico inicial";

            this.chartData.evolution.data[label] = Number.parseInt(
              item[this.propertyToShowInGraph]
            );
          }

          let label = "";

          switch (evolution) {
            case 1:
              label = "% de logro";
              break;
            case 2:
              label = "Evolucion de desafíos";
              break;
            case 3:
              label = "Evolucion de las evaluaciones de libros";
              break;
          }

          this.chartData.evolution.label = label;

          this.statusEvolution.showData = true;
        } else {
          this.error = data.content;
          // this.$notify({
          //   title: ["Ocurrió un error"],
          //   type: "danger",
          // });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.statusEvolution.showSpinner = false;
      }
    },
    toggleDetails(visible) {
      this.showDetails = visible;
      if (!visible) {
        this.individualResults = false;
        this.selectedStudent = null;
      }
    },
    toggleIndividualResults() {
      this.individualResults = !this.individualResults;
      if (!this.individualResults) {
        this.selectedStudent = null;
      }
    },
    setSelectedChart(chart) {
      this.selectedChart = chart;
    },
    selectStudent(i) {
      this.selectedStudent = i;
    },
  },
  computed: {
    propertyToShowInGraph() {
      if (this.general) return "porcentajeCorrectas";
      return this.selectHability.selected;
    },
    ...mapState(["dataUrl", "reports"]),
    individualResultButton() {
      if (this.individualResults) {
        return "Dejar de ver";
      } else {
        return "Ver resultados individuales";
      }
    },
    studentButtonText() {
      let text = "Ver detalles";
      if (this.studentsDetail) text = "Ocultar detalles";
      return text;
    },
  },
  mounted() {
    this.storeDates();
  },
};
</script>

<style lang="scss" scoped>
.custom-scroll {
  max-height: 300px;
  overflow: auto;
  display: block;
  width: 100%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  tr {
    display: flex;
    td {
      width: 100%;
      border-radius: 0;
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
